module.exports = __webpack_public_path__ + "img/travel-agency__content-creation_and_layout.97e4cce0.jpg";